import { Dialog, DialogContentText, Grid, makeStyles } from "@material-ui/core";
import React from "react";
import StepWizard from "react-step-wizard";
import { InformationModal } from "./informationModal";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import styles from "./informationModal.module.scss";
import { EnterPhoneNumber } from "./enterPhoneNumber";
import { VerificationCode } from "./verificationCode";
import { useTranslation } from "react-i18next";
interface ITwoFactorStepper {
  onClose(): any;
  open: boolean;
  initialStep?: number;
  phoneNumberToDelete?: string;
}

const useStyles = makeStyles({
  paper: {
    minWidth: "100%",
    position: "absolute",
    bottom: 0,
    margin: 0,
    borderRadius: 0,
  },
});

export const TwoFactorStepper: React.FC<ITwoFactorStepper> = (props) => {
  const classes = useStyles();
  const { open, onClose, initialStep, phoneNumberToDelete } = props;
  const [activeStepOutter, setActiveStepOutter] = React.useState<number>(
    initialStep ? initialStep : 1
  );
  const [proposedPhoneNumber, setProposedPhoneNumber] =
    React.useState<string>("");
  const [instance, setInstance] = React.useState<any>();

  const dontShowBack =
    initialStep === 2 && activeStepOutter === 2 ? true : false;

  const handleFinalOnClose = () => {
    setActiveStepOutter(1);
    setProposedPhoneNumber("");
    //@ts-ignore
    onClose(true);
  };
  const { t } = useTranslation();
  return (
    <Dialog
      onClose={() => onClose()}
      open={open}
      classes={{ paper: classes.paper }}
    >
      <Grid container direction="column" wrap="nowrap">
        <Grid
          container
          direction="row"
          justifyContent={
            activeStepOutter > 1 && !dontShowBack ? "space-between" : "flex-end"
          }
        >
          {activeStepOutter > 1 && !dontShowBack && (
            <Grid item onClick={() => instance.goToStep(activeStepOutter - 1)}>
              <div className={styles.cross}>
                <ArrowBackIcon fontSize="medium" color="primary" />
                <DialogContentText color="primary">
                  {t("Back")}
                </DialogContentText>
              </div>
            </Grid>
          )}
          <Grid item onClick={() => onClose()}>
            <div className={styles.cross}>
              <CloseIcon fontSize="medium" color="primary" />
              <DialogContentText color="primary">
                {t("Close")}
              </DialogContentText>
            </div>
          </Grid>
        </Grid>
        <StepWizard
          onStepChange={(stepChange) =>
            setActiveStepOutter(stepChange.activeStep)
          }
          instance={(instance) => setInstance(instance)}
          initialStep={activeStepOutter}
        >
          <InformationModal />
          <EnterPhoneNumber
            setProposedPhoneNumber={setProposedPhoneNumber}
            phoneNumber={proposedPhoneNumber}
          />
          <VerificationCode
            onClose={handleFinalOnClose}
            phoneNumber={proposedPhoneNumber}
            shouldDeletePhoneNumber={phoneNumberToDelete}
          />
        </StepWizard>
      </Grid>
    </Dialog>
  );
};
